module.exports = __webpack_public_path__ + "images/_/programs/zeroHeroes/images/characters/apprenticesBackToBack-3828e498bf581cc27ecb2f351a349b23.png";


//////////////////
// WEBPACK FOOTER
// ./programs/zeroHeroes/images/characters/apprenticesBackToBack.png
// module id = 2483
// module chunks = 2